module.exports = __webpack_public_path__ + "img/door.1611cd77.svg";